define('modules/form_editor/views/preview_custom_email',['require','exports','module','./preview_base','../../editor/models/editorstate','ldsh!../templates/preview_custom_email_amp','ldsh!../templates/preview_custom_email'],function(require, exports, module){
  "use strict";
  var InputBase = require("./preview_base"),
      EditorState = require("../../editor/models/editorstate");

  module.exports = InputBase.extend({
    template: null,
    initialize: function(options) {
      this.template = EditorState.getAMPState() ?
          require("ldsh!../templates/preview_custom_email_amp") : require("ldsh!../templates/preview_custom_email");
      module.exports.__super__.initialize.apply(this, arguments);
    }
  });
});

